<button type="button"  mat-button (click)="this.handleBackward()">
  <div class="button__container">
    <ogs-m3-icon prefix="fal" icon="arrow-left-long"/>
    <span class="mat-label-large">{{"Zurück" | translate : "action-return"}}</span>
  </div>
</button>
<app-authenticate-ui-headline>
	<app-authenticate-ui-headline-title>
		{{"Passwort Vergessen" | translate : "label-header-headline"}}
	</app-authenticate-ui-headline-title>
  <app-authenticate-ui-headline-description>
			{{"Geben Sie bitte Ihre registrierte E-Mail Adresse ein und drücken Sie \"Passwort zurücksetzen\". Danach wird Ihnen eine E-Mail mit einem Link zugesandt.\nMit diesem Link können Sie ein neues Passwort vergeben. Falls Sie keine E-Mail erhalten haben, schauen Sie bitte auch in Ihrem Spam-Ordner nach." | translate : "label-header-description" : "feature/auth/forgot-password"}}
  </app-authenticate-ui-headline-description>
</app-authenticate-ui-headline>
<app-shared-caps-lock-notice />
<form [formGroup]="this.formGroup" (ngSubmit)="this.handleSubmit()">
  <mat-form-field>
    <mat-label>{{"Email Adresse" | translate : "input-email"}}</mat-label>
    <input type="email" matInput formControlName="email" />
    @if (this.formGroup.get("email")?.value) {
      <button type="button" mat-icon-button matSuffix tabindex="-1" (click)="this.handleClear()">
        <ogs-m3-icon prefix="fal" icon="times"/>
      </button>
    }
  </mat-form-field>
		@if(isEmailSent()){
					<app-shared-notify-chip status="success">
			<ogs-m3-icon prefix="fal" icon="paper-plane"/>
			<app-shared-notify-chip-value>
				{{"Email wurde versendet" | translate : "status-email-sent"}}
			</app-shared-notify-chip-value>
		</app-shared-notify-chip>
		}
		@else {
  <button mat-flat-button type="submit" class="button--tertiary" [disabled]="!this.formGroup.valid || isLoading()">
    {{"Absenden" | translate : "action-reset-password"}}
  </button>
		}
</form>
